// extracted by mini-css-extract-plugin
module.exports = {"buttons":"Review_buttons__Ah2La","inline":"Review_inline__17y4O","nomargin":"Review_nomargin__2meiR"};